import {WagonsNumberToAssign} from "../models/order";
import http from "../../common/services/httpService";
import {Api, apiUrls, PaginationParams, SortingAndFilteringParams} from "../../helpers/api";
import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {
    DepoFlowActions,
    CurrentStatusModel,
    NewOrUpdateOrderModel,
    OrderCargoFileModel,
    OrderDetailModel,
    OrderModel,
    TrailerOrContainerOrderFileModel
} from "../models/order";
import {RelationType} from "../models/relation";
import {HttpErrorModel} from "../../common/models/httpError";
import {PhotosModel} from "../models/photos";
import {TransportationFilters} from "../models/transport";

export class OrderService {
    private static baseUrl = apiUrls.transportation.transportation;

    public static async getAllOrders(filters: TransportationFilters, paginationParams: PaginationParams, sortingAndFilteringParams: SortingAndFilteringParams, search: string): Promise<AxiosResponse<PageableModel<OrderModel>>> {
        const trailerNo = search && `,trailerNo_:${search}`;
        sortingAndFilteringParams.filterCondition = `relationType:!:${RelationType.TICKET_EXPORT}${this.getQuery(filters)}${trailerNo}`;

        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.baseUrl), sortingAndFilteringParams);

        return await http.get(`${Api.addPaginationParams(url, paginationParams)}`);
    }

    public static async getOrder(id: string): Promise<AxiosResponse<OrderDetailModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}`);
    }

    public static async getOrderStatus(id: string): Promise<AxiosResponse<CurrentStatusModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}/status`);
    }

    public static async changeOrderStatus(id: string, action: DepoFlowActions, locationId?: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/${id}/change-status`, {action, locationId});
    }

    public static async getAllPhotos(orderId: string): Promise<AxiosResponse<PhotosModel[]>> {
        return await http.get(`${Api.getUrl(apiUrls.photos.photoList)}/${orderId}`);
    }

    public static async getOrderCargoDataForFile(id: string): Promise<AxiosResponse<OrderCargoFileModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}/order-cargo-file`);
    }

    public static async getTrailerOrContainerOrderDataForFile(id: string): Promise<AxiosResponse<TrailerOrContainerOrderFileModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}/trailer-or-container-order-file`);
    }

    public static async addOrder(data: NewOrUpdateOrderModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/order`, data);
    }

    public static async modifyOrder(data: NewOrUpdateOrderModel, id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/order/${id}/update`, data);
    }

    public static async allowOrNotAllowLocation(orderId: string, locationId: string, allow: boolean): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        const urlSuffix = allow ? "allow" : "disallow";

        return await http.post(`${Api.getUrl(apiUrls.place.entryOrExit)}/${locationId}/${urlSuffix}/${orderId}`);
    }

    public static async assignWagonsNumber(orderId: string, wagonsNumber: WagonsNumberToAssign): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/order/${orderId}/assign-wagon-number`, wagonsNumber);
    }

    public static async cancelOrder(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.delete(`${Api.getUrl(this.baseUrl)}/order/${id}/cancel`);
    }

    private static getQuery(filters: TransportationFilters) {
        const createdAt = `${(filters.dateOfRegistrationFrom && `,createdAt>=${filters.dateOfRegistrationFrom}`)}` + (filters.dateOfRegistrationTo && `,createdAt<=${filters.dateOfRegistrationTo}`);
        const status =  filters.status && `,status::${filters.status}`;
        const relationType = filters.relationType && `,relationType::${filters.relationType}`;
        const ferryEntityId = filters.ferryEntityId && `,ferry.entityId::${filters.ferryEntityId}`;
        const arrivalDepartureTime = filters.arrivalDepartureTime && `,arrivalDepartureTime::${filters.arrivalDepartureTime}`;

        return createdAt + status + relationType + ferryEntityId + arrivalDepartureTime;
    }
}
